import React from "react"
import PropTypes from "prop-types"
import { Modal, Drawer, Button, Flex } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import styles from "./Index.module.css"
import { useDevice } from "hooks/useDevice"
import warningIcon from "assets/icons/warningIcon.svg"

const DiscardConfirm = ({
  open,
  onCancel,
  onConfirm,
  title = "Discard changes?",
  description = "Are you sure you want to discard your changes?",
  t
}) => {
  const { isMobile } = useDevice()
  const TitleContent = (
    <div>
      <Flex className="w-full mb-s" justify="space-between" align="center">
        <Flex justify="center" align="center" className={`w-max ${styles.warningIcon}`}>
          <img src={warningIcon} alt="warning" width="24" height="24" />
        </Flex>
        <Button type="text" onClick={onCancel} className={`${styles.closeButton} p-0`}>
          <CloseOutlined />
        </Button>
      </Flex>
      {title}
    </div>
  )

  const FooterButtons = (
    <Flex vertical gap="small" justify="center">
      <Button key={t("global.no")} color="primary" variant="outlined" onClick={onCancel}>
        {t("global.no")}
      </Button>
      <Button key={t("global.yes")} type="primary" danger onClick={onConfirm}>
        {t("global.yes")}
      </Button>
    </Flex>
  )

  return isMobile ? (
    <Drawer
      open={open}
      placement="bottom"
      height="auto"
      closable={false}
      onClose={onCancel}
      title={
        <Flex justify="space-between" align="center">
          <div className="flex-1 text-center">{title}</div>
          <Button type="text" onClick={onCancel} className={`${styles.closeButton} ml-auto p-0`}>
            <CloseOutlined />
          </Button>
        </Flex>
      }
      footer={FooterButtons}
    >
      <Flex justify="center" align="center" className={`mb-xl ${styles.warningIcon}`}>
        <img src={warningIcon} alt="warning" width="24" height="24" />
      </Flex>
      <p>{description}</p>
    </Drawer>
  ) : (
    <Modal
      open={open}
      onCancel={onCancel}
      className={styles.discardAlertModal}
      closable={false}
      title={TitleContent}
      footer={[
        <Button key={t("global.no")} color="primary" variant="outlined" onClick={onCancel}>
          {t("global.no")}
        </Button>,
        <Button key={t("global.yes")} type="primary" danger onClick={onConfirm}>
          {t("global.yes")}
        </Button>
      ]}
    >
      <p>{description}</p>
    </Modal>
  )
}

DiscardConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  t: PropTypes.func.isRequired
}

export default DiscardConfirm
